export const filterUsers = (users, id) => {
  return users.filter((e) => e._id !== id);
};

export const getUser = (state) => {
  const currentUser = state.auth.user;

  if (currentUser) {
    return {
      email: currentUser.email,
      rank: currentUser.rank,
      username: currentUser.username,
      enterpriseName: currentUser.enterpriseName,
      avatarURL: currentUser.avatarURL
    };
  }

  return false;
};
